import { PageVariant } from 'fitify-ui-landing/src/@types/PageVariant'
import BusinessContact from 'fitify-ui-landing/src/components/blocks/Contact/BusinessContact'
import Features from 'fitify-ui-landing/src/components/blocks/Features/Features'
import BusinessHeader from 'fitify-ui-landing/src/components/blocks/Header/BusinessHeader'
import HowItWorks from 'fitify-ui-landing/src/components/blocks/HowItWorks/HowItWorks'
import Mentions from 'fitify-ui-landing/src/components/blocks/Mentions/Mentions'
import Reviews from 'fitify-ui-landing/src/components/blocks/Reviews/Reviews'
import WorkStatistics from 'fitify-ui-landing/src/components/blocks/WorkStatistics/WorkStatistics'
import type { NextPage } from 'next'
import { useTranslation } from 'next-i18next'

import Layout from '@/components/layouts/Layout'
import { businessFeaturesData } from '@/data/features'
import { businessHeaderImage } from '@/data/header'
import { businessHowItWorksData } from '@/data/how-it-works'
import { mentionsData } from '@/data/mentions'
import { businessReviewsData } from '@/data/reviews'
import { workStatisticsData } from '@/data/work-statistics'
import { getStaticPropsTranslations } from '@/utils/i18n'

const Home: NextPage = () => {
  const { t } = useTranslation()

  return (
    <Layout
      shouldHideNewsletter
      isBusiness
      seo={{
        title: t('landing_work_section_title_for_business') + ' | Fitify',
        description: t('landing_work_subheadline'),
      }}
    >
      <BusinessHeader
        headerImage={businessHeaderImage}
        headline={'landing_work_headline'}
        subheadline={'landing_work_subheadline'}
        buttonCta={'landing_work_cta_contact_us'}
        buttonVariant={'primary-blue'}
      />

      <Features items={businessFeaturesData} />
      <HowItWorks
        title={t('landing_work_how_it_works_block_title')}
        columns={2}
        variant={PageVariant.BUSINESS}
        items={businessHowItWorksData}
      />
      <Mentions mentionsItems={mentionsData} />
      <WorkStatistics
        items={workStatisticsData}
        headline={'landing_work_statistics_title'}
        note={'landing_work_statistics_note'}
      />
      <Reviews
        headline={'landing_work_review_title'}
        items={businessReviewsData}
        isBusiness
      />
      <BusinessContact
        titleText={t('landing_work_contact_block_title')}
        subtitleText={t('landing_work_contact_block_subtitle')}
        emailText={t('landing_work_contact_block_email')}
        nameText={t('landing_work_contact_block_name')}
        ctaText={t('landing_work_contact_block_cta')}
        successMessageText={t('landing_work_contact_success_message')}
        countryText={t('landing_work_contact_block_country')}
        companyAndJobText={t('landing_work_contact_block_company_and_job')}
        nameErrorText={t('landing_work_contact_block_name_error')}
        emailErrorText={t('landing_work_contact_block_email_error')}
        countryErrorText={t('landing_work_contact_block_country_error')}
        companyAndJobErrorText={t(
          'landing_work_contact_block_company_and_job_error'
        )}
      />
    </Layout>
  )
}

export default Home

export async function getStaticProps({ locale }: { locale: string }) {
  return {
    props: {
      ...(await getStaticPropsTranslations(locale)),
    },
  }
}
